angular.module('commerce').factory('CommerceSubscription', [
    'ShareCrfSDK',
    function(ShareCrfSDK) {
        return {
            getCurrentLicense: function(studySubdomain) {
                return ShareCrfSDK.portal.studies.getCurrentLicense(studySubdomain);
            },
        };
    },
]);
